/**
 * Brand hero: the video fades in over the still once it is actually playing,
 * so the still is what visitors see while the file loads.
 *
 * The manufacturer star (top centre) and wordmark (bottom centre)
 * start hidden and fade in on the visitor's first pointer movement. Touch, scroll and key
 * presses count too, so phones and keyboard users are not left without them.
 * In the theme editor and for reduced motion the row is shown at once.
 */
const heroes = document.querySelectorAll('.brand-hero');
heroes.forEach((hero) => {
  const wrap = hero.querySelector('.brand-hero__video');
  const video = wrap && wrap.querySelector('video');
  if (!video) return;
  const show = () => wrap.classList.add('brand-hero__video--playing');
  video.addEventListener('playing', show, { once: true });
  if (!video.paused && video.readyState >= 3) show();
  const attempt = video.play();
  if (attempt && attempt.catch) attempt.catch(() => {});
});
if (heroes.length) {
  const reveal = () => heroes.forEach((hero) => hero.classList.add('brand-hero--revealed'));
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced || (window.Shopify && window.Shopify.designMode)) {
    reveal();
  } else {
    const options = { once: true, passive: true };
    ['pointermove', 'pointerdown', 'touchstart', 'wheel', 'keydown', 'scroll'].forEach((type) => {
      window.addEventListener(type, reveal, options);
    });
  }
}
